import { ServiceId } from "@mirage/discovery/id";
import * as services from "@mirage/discovery/services";
import * as rx from "rxjs";
import type { Service } from "./service";

export const service = services.get<Service>(ServiceId.SESSIONS);

export function createOrGetSessionId(
  type: string,
  ownerId: string,
): Promise<string> {
  return rx.firstValueFrom(service.createOrGetSessionId(type, ownerId));
}

export function deleteSessionId(type: string, ownerId: string): Promise<void> {
  return rx.firstValueFrom(service.deleteSessionId(type, ownerId));
}

export function clearSessionIds(): Promise<void> {
  return rx.firstValueFrom(service.clearSessionIds());
}
